import React from 'react';
import { formatDate } from '../i18n';
import { Avatar, Rating } from '../ui';

/** Carte commentaire : auteur (véhicule en avatar), note, texte. */
export default function ReviewCard({ review, action }) {
    const vehicle = (review.owner && review.owner.type_vehicule) || 'nc';
    return (
        <article style={{ display: 'flex', gap: 12, padding: '16px 0', borderBottom: '1px solid var(--border-1)' }}>
            <Avatar
                src={`/img/bitmap/vehicules/vehicule_${String(vehicle).toLowerCase()}.png`}
                name={review.owner ? review.owner.username : '?'}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                    <div>
                        <strong>{review.owner ? review.owner.username : '—'}</strong>
                        <span className="text-muted text-sm" style={{ marginLeft: 8 }}>
                            {formatDate(review.date_creation)}
                        </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {review.note != null && <Rating value={review.note} />}
                        {action}
                    </div>
                </div>
                <p className="text-sm" style={{ margin: '6px 0 0', whiteSpace: 'pre-wrap' }}>{review.commentaire}</p>
            </div>
        </article>
    );
}
